<template>
  <div class="login-container">
    <h2>Instapaper Login</h2>
    <form @submit.prevent="handleLogin">
      <div class="form-group">
        <label for="username">Username:</label>
        <input type="text" id="username" v-model="username" required>
      </div>
      <div class="form-group">
        <label for="password">Password:</label>
        <input type="password" id="password" v-model="password" required>
      </div>
      <button type="submit">Login</button>
    </form>
    <p v-if="errorMessage" class="error-message">{{ errorMessage }}</p>
  </div>
</template>

<script>
import Cookies from 'js-cookie';

export default {
  name: 'UserLogin', // Renamed from 'Login' to avoid potential conflicts if 'Login' is a reserved word or common pattern
  data() {
    return {
      username: '',
      password: '',
      errorMessage: '' // To display login errors
    };
  },
  methods: {
    async handleLogin() {
      this.errorMessage = ''; // Clear previous errors
      console.log('Attempting login for:', this.username);

      try {
        const response = await fetch('/api/instapaper/login', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            username: this.username,
            password: this.password,
          }),
        });

        // We'll process the response (success/failure) in the next steps
        if (!response.ok) {
          // Try to parse error from backend if response body exists
          let errorData = { message: `HTTP error! status: ${response.status}` };
          try {
            const body = await response.json();
            errorData = body.detail || body; // Use detail if available (FastAPI standard)
          } catch (e) {
            // Ignore if response body is not JSON or empty
            console.warn("Could not parse error response body:", e);
          }
          console.error('Login failed:', errorData);
          // Placeholder for setting error message for the user
          this.errorMessage = typeof errorData === 'string' ? errorData : errorData.message || 'Login failed. Please check your credentials.';
        } else {
          const data = await response.json();
          console.log('Login successful, response data:', data);
          // Handle successful login: Store tokens in cookies
          if (data.oauth_token) {
            Cookies.set('instapaper_oauth_token', data.oauth_token, { expires: 7, path: '/' });
            console.log('Tokens stored in cookies.');

            // Emit event to notify parent component
            this.$emit('login-success');

            // Clear form (optional, can be kept or removed)
            this.username = '';
            this.password = '';
            // Removed alert('Login Successful!');
            // In a real app, you might redirect or update UI state here
          } else {
            console.error('Login successful but tokens missing in response:', data);
            this.errorMessage = 'Login succeeded but failed to retrieve authentication tokens.';
          }
        }
      } catch (error) {
        console.error('Network or other error during login:', error);
        this.errorMessage = 'An error occurred during login. Please try again later.';
      }
    }
  }
};
</script>

<style scoped>
.login-container {
  max-width: 300px;
  margin: 50px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  text-align: left;
}
.form-group {
  margin-bottom: 15px;
}
.form-group label {
  display: block;
  margin-bottom: 5px;
}
.form-group input {
  width: 100%;
  padding: 8px;
  box-sizing: border-box; /* Ensures padding doesn't add to width */
}
button {
  padding: 10px 15px;
  background-color: #42b983; /* Vue green */
  color: white;
  border: none;
  border-radius: 3px;
  cursor: pointer;
  width: 100%; /* Make button full width */
}
button:hover {
  background-color: #36a476;
}
.error-message {
  color: red;
  margin-top: 15px;
  text-align: center; /* Center error message */
}
</style>
